export default "__VITE_ASSET__jaTgN9QR__"